import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Menu from '../components/Menu'
import { FooterSection } from '../components/Footer'

function About() {
    return (
        <AnimatePresence>
            <Menu />
            <motion.div className="about-page"
                initial={{ opacity: 0.5 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.5 }}
                transition={{ duration: 0.8, type: "tween" }}
            >
                <div className="about-page-content">
                    {/* about page big title */}
                    <section className="about-page-jumbotron">
                        <div className="jumbotron-image">
                            <img src="" alt="" />
                        </div>
                        <nav className="jumbotron-title">
                            <h1>Noxturne</h1>
                            <h2>Galih Adhi Kusuma</h2>
                        </nav>
                    </section>
                    {/* description container */}
                    <section className="about-page-description">
                        <div className="about-desc-header">
                            <div className="title">
                                about
                            </div>
                            <div className="divider">
                                <hr />
                            </div>
                        </div>
                        {/* description main content */}
                        <div className="about-desc">
                            <div className="desc-title">
                                <h1>Who am i?</h1>
                            </div>
                            <div className="desc-paragraph">
                                <p>Hello my name is Galih, and as you can see i am a web developer. I mainly focused on front-end development using HTML, CSS, and JavaScript. I handled a lot of front end based project such as CMS, Landing Page, and so on</p>
                                <p>Im from Tangerang, Indonesia. I really loved to code, anythin that need to be coded, im down for it. </p>
                            </div>
                        </div>
                        <div className="about-desc">
                            <div className="desc-title">
                                <h1>Skills and Tech stack</h1>
                            </div>
                            <div className="desc-paragraph">
                                <p>Here's all the tech stack, framework, language and library</p>
                                <p>HTML, JavaScript (ReactJS), CSS (SASS, TailwindCSS, Bootstrap), Animation (GSAP, Framer-motion). Im beginner at NodeJS, ExpresJS, MySql, Sequilize, MongoDB</p>
                            </div>
                        </div>
                    </section>
                    <FooterSection />
                </div>
            </motion.div >
        </AnimatePresence >
    )
}

export default About